import {
  ExpressionType,
  FieldRefSource,
  TParamValue,
  TValueProvider,
} from '@commenda/types/src/workflow/dsl';

const getDefaultConstObj = (val: unknown = ''): TValueProvider => ({
  type: 'const',
  value: val,
});
const getDefaultFieldRefObj = (): TValueProvider => ({
  type: 'field',
  ref: { source: FieldRefSource.CONTEXT, path: '' },
});
const getDefaultExprObj = (): TValueProvider => ({
  type: 'expr',
  expr: { type: ExpressionType.JSONATA, src: '' },
});

const isParamValueObject = (
  obj: unknown
): obj is Record<string, TParamValue> => {
  return (
    !!obj &&
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    !('type' in (obj as any))
  );
};

const isParamValueProvider = (obj: unknown): obj is TValueProvider => {
  return (
    !!obj &&
    typeof obj === 'object' &&
    (obj as any).type !== undefined &&
    typeof (obj as any).type === 'string' &&
    (((obj as any).type === 'const' && 'value' in obj) ||
      ((obj as any).type === 'field' && 'ref' in obj) ||
      ((obj as any).type === 'expr' && 'expr' in obj))
  );
};

const isParamValueArray = (obj: unknown): obj is TParamValue[] => {
  return Array.isArray(obj);
};

export {
  getDefaultConstObj,
  getDefaultExprObj,
  getDefaultFieldRefObj,
  isParamValueArray,
  isParamValueObject,
  isParamValueProvider,
};
